import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Breadcrumbs = ({ items }) => {
  const { language } = useLanguage();

  // Schema.org BreadcrumbList
  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": item.url ? `https://allmx.it${item.url}` : undefined
    }))
  };

  return (
    <>
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>

      {/* Visual Breadcrumbs */}
      <nav className="flex items-center gap-2 text-sm mb-6" aria-label="Breadcrumb">
        <Link 
          to="/" 
          className="flex items-center gap-1 hover:text-primary transition-colors"
          style={{ color: 'var(--text-muted)' }}
        >
          <Home size={16} />
          <span>{language === 'it' ? 'Home' : 'Home'}</span>
        </Link>

        {items.map((item, index) => (
          <React.Fragment key={item.label || `crumb-${index}`}>
            <ChevronRight size={16} style={{ color: 'var(--text-muted)' }} />
            {item.url ? (
              <Link 
                to={item.url}
                className="hover:text-primary transition-colors"
                style={{ color: 'var(--text-muted)' }}
              >
                {item.label}
              </Link>
            ) : (
              <span style={{ color: 'var(--text-primary)' }} className="font-semibold">
                {item.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
};

export default Breadcrumbs;
